export class GarantiaDtoSimple {
  
    public id : number=0;
    public tipoGarantia:string=""
    public razonSocial : string="";
    public nroFolio : string="";
    public cuitCuil : string="";
    public sueldo : number=0;
}
